export default {
  // list
  'menu.query.menuName': 'Menu Name',
  'menu.query.menuName.placeholder': 'Enter menu name',
  'menu.query.expandAll': 'Expand All',
  'menu.query.collapseAll': 'Collapse All',
  'menu.column.menuName': 'Menu Name',
  'menu.column.menuType': 'Menu Type',
  'menu.column.menuIcon': 'Icon',
  'menu.column.sortNum': 'Sort Order',
  'menu.column.path': 'Route Path',
  'menu.column.permission': 'Permission',
  'menu.column.component': 'Component Path',
  'menu.column.status': 'Status',
  'menu.column.status.normal': 'Normal',
  'menu.column.status.disabled': 'Disabled',
  'menu.column.visible': 'Visible',
  'menu.column.visible.true': 'Yes',
  'menu.column.visible.false': 'No',
  'menu.column.cache': 'Cache Enabled',
  'menu.column.cache.true': 'Yes',
  'menu.column.cache.false': 'No',
  'menu.column.dot.true': 'Yes',
  'menu.confirm.delete': 'Are you sure you want to delete "{menuName}" and all its submenus?',
  // edit
  'menu.edit.title': 'Edit Menu',
  'menu.add.title': 'Add Menu',
  'menu.add.success': 'Added Successfully',
  'menu.edit.success': 'Edit Successful',
  'menu.edit.form.parentId': 'Parent Menu',
  'menu.edit.form.parentId.placeholder': 'Select Parent Menu',
  'menu.edit.form.menuType': 'Menu Type',
  'menu.edit.form.menuType.required': 'Please select a menu type',
  'menu.edit.form.menuName': 'Menu Name',
  'menu.edit.form.menuName.placeholder': 'Enter Menu Name',
  'menu.edit.form.menuName.required': 'Please enter the menu name',
  'menu.edit.form.status': 'Menu Status',
  'menu.edit.form.status.required': 'Please select a menu status',
  'menu.edit.form.status.normal': 'Normal',
  'menu.edit.form.status.disabled': 'Disabled',
  'menu.edit.form.sortNum': 'Display Order',
  'menu.edit.form.sortNum.placeholder': 'Enter Display Order',
  'menu.edit.form.sortNum.required': 'Please enter the display order',
  'menu.edit.form.path': 'Route Path',
  'menu.edit.form.path.required': 'Please enter a route path',
  'menu.edit.form.path.placeholder': 'Enter Route Path',
  'menu.edit.form.menuIcon': 'Menu Icon',
  'menu.edit.form.menuIcon.placeholder': 'Select Menu Icon',
  'menu.edit.form.embed': 'Embed',
  'menu.edit.form.embedUrl': 'Embed URL',
  'menu.edit.form.embedUrl.placeholder': 'Enter Embed URL',
  'menu.edit.form.component': 'Component Path',
  'menu.edit.form.component.placeholder': 'Use "@/views/" as a relative path',
  'menu.edit.form.component.required': 'Please enter the component path',
  'menu.edit.form.componentName': 'Component Name',
  'menu.edit.form.componentName.placeholder': 'Enter Component Name',
  'menu.edit.form.permission': 'Permission',
  'menu.edit.form.permission.placeholder': 'Enter Permission',
  'menu.edit.form.visible': 'Show in Menu Bar',
  'menu.edit.form.alwaysShow': 'Always Show',
  'menu.edit.form.alwaysShow.tooltip': 'Whether to keep this directory visible when it has only one submenu. true: Show the directory, false: Hide the directory and directly show the submenu',
  'menu.edit.form.cache': 'Enable Cache',
  'menu.edit.form.showHeader': 'Show Header',
  'menu.edit.form.showFooter': 'Show Footer',
  'menu.edit.form.badge.placeholder': 'Enter badge',
}
